<template>
  <main class="login">
    <section class="tam-2 cover"></section>
    <section class="alinha-v rel">
      <div class="margem">
        <form @submit.prevent="login">
          <p class="logo">Thalamus</p>
          <p v-if="modoAdicionarConta" class="login-add-account">Adicionar conta</p>
          <fieldset>
            <div class="linha">
              <label class="icone-conta pos-input"></label>
              <input type="text" v-model="email" placeholder="E-mail" />
            </div>
            <div class="linha">
              <label class="icone-senha pos-input"></label>
              <input type="password" v-model="password" placeholder="Senha" />
              <a href="" class="icone-olho" onclick="var inp=this.previousElementSibling;inp.type==='password'?inp.type='text':inp.type='password';return false"></a>
            </div>
          </fieldset>
          <div class="grid-2">
            <div class="submit">
              <button type="submit"><span class="icone-avancar direita"></span>Entrar</button>
            </div>
            <div class="login-ajuda-senha">
              <RouterLink :to="{ name: 'EsqueciMinhaSenha', query: { motivo: 'esqueci' } }" class="botao link-ajuda-senha"> Esqueci minha senha </RouterLink>
              <span class="login-ajuda-sep" aria-hidden="true">·</span>
              <RouterLink :to="{ name: 'EsqueciMinhaSenha', query: { motivo: 'primeiro-acesso' } }" class="botao link-ajuda-senha"> Primeiro acesso </RouterLink>
            </div>
          </div>
          <div class="login-divisor">
            <span>ou</span>
          </div>
          <button type="button" class="btn-google" @click="loginGoogle" :disabled="isLoading" aria-label="Entrar com o Google">
            <span class="btn-google__icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.56 2.95-2.23 5.45-4.64 7.15l7.19 5.58C43.98 37.99 48 31.83 48 24.55z" />
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.19-5.58c-2.01 1.35-4.59 2.16-8.7 2.16-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
              </svg>
            </span>
            <span class="btn-google__text">Entrar com o Google</span>
          </button>
          <div>
            <div v-if="isLoading" class="loading">
              <div></div>
            </div>
          </div>
        </form>
      </div>

      <div class="alinha-v abs" id="empresa">
        <div class="margem">
          <h2>Selecione a área</h2>
          <div class="sel-area">
            <a href="javascript:void(0)" v-for="local in locaisList" :key="local.id" @click="selecionaLocal(local.id)" class="item"><span class="icone-avancar direita"></span>{{ local.local_nome }}</a>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import { onMounted, onBeforeUnmount, ref, computed } from "vue";
import { createToaster } from "@meforma/vue-toaster";
import { sso } from "roboflex-thalamus-sso-lib";
import { syncTenantKey } from "roboflex-thalamus-request-handler";
import { useRoute, useRouter } from "vue-router";
import localService from "../services/localService";
import authService from "../services/authService";
import googleOneTapService from "../services/googleOneTapService";
import {
  enriquecerSessaoComMe,
  paramsLoginMultiConta,
  redirecionarAposLogin,
  registrarSessaoNoCofre,
} from "@/services/sessionService";

const toaster = createToaster({
  position: "top-right",
  duration: 4000,
});

export default {
  setup() {
    let email = ref("");
    let password = ref("");
    let isLoading = ref(false);
    let locaisList = ref(new Array());
    let usuarioLogado = ref();

    const router = useRouter();
    const route = useRoute();
    const modoAdicionarConta = computed(() => paramsLoginMultiConta(route).addAccount);

    const avisarCofreSeNecessario = (vaultError) => {
      if (!vaultError) return;
      toaster.show(
        vaultError.message || "Limite de contas salvas atingido. Remova uma no menu do perfil.",
        { type: "warning" }
      );
    };

    const concluirLogin = async (usuario) => {
      const { vaultError } = registrarSessaoNoCofre(usuario);
      avisarCofreSeNecessario(vaultError);
      syncTenantKey();
      redirecionarAposLogin(usuario, router, route);
    };

    const processarCredencialGoogle = async (credential) => {
      if (isLoading.value) return;
      isLoading.value = true;
      try {
        const payload = await authService.loginOneTap(credential);
        authService.registrarSessaoGoogle(payload);
        syncTenantKey();
        const usuario = await enriquecerSessaoComMe();
        await concluirLogin(usuario);
      } catch (e) {
        const codeErr = e.response?.data?.code || "oauth_failed";
        toaster.show(authService.mensagemErroGoogle(String(codeErr)), { type: "error" });
      } finally {
        isLoading.value = false;
      }
    };

    const tentarOneTap = () => {
      if (modoAdicionarConta.value) return;
      if (!googleOneTapService.getGoogleClientId() || isLoading.value) {
        return;
      }
      googleOneTapService.iniciarOneTap({ onCredential: processarCredencialGoogle }).catch(() => {
        // One Tap indisponível — usuário usa o botão manual.
      });
    };

    onMounted(async () => {
      // Em "adicionar conta", mantém a tela de login mesmo com sessão ativa.
      if (sso.validarSessao() && !modoAdicionarConta.value) {
        try {
          syncTenantKey();
          const usuario = await enriquecerSessaoComMe();
          if (!sso.validarSessao() || !usuario?.token) return;
          redirecionarAposLogin(usuario, router, route);
        } catch {
          // Sessão rejeitada pela API: o formulário permanece na tela.
        }
        return;
      }

      tentarOneTap();
    });

    onBeforeUnmount(() => {
      // Não chamar cancel() aqui — o Google interpreta como dismiss e suprime o prompt por horas.
    });

    /**
     * Login: em development usa API local; em demais ambientes, SSO.
     */
    const login = async () => {
      if (!email.value || !password.value) {
        toaster.show(`Preencha e-mail e senha`, { type: "error" });
        return;
      }

      isLoading.value = true;

      try {
        if (authService.usarLoginLocal()) {
          const payload = await authService.loginLocal(email.value, password.value);
          let usuario = authService.registrarSessaoGoogle(payload);
          // Atualiza chave de tenant antes do /auth/me para não tratar login como troca de empresa.
          syncTenantKey();
          try {
            const enriquecido = await enriquecerSessaoComMe();
            if (enriquecido?.token) {
              usuario = enriquecido;
            }
          } catch {
            // sessão já está no cookie; segue
          }
          isLoading.value = false;
          await concluirLogin(usuario);
          return;
        }

        const usuLogado = await sso.login(email.value, password.value);
        usuarioLogado.value = usuLogado;
        syncTenantKey();
        isLoading.value = false;
        const usuario = await enriquecerSessaoComMe();
        await concluirLogin(usuario);
      } catch (error) {
        isLoading.value = false;
        const code = error.response?.data?.code;
        const msg = error.response?.data?.message || authService.mensagemErroLogin(code) || `E-mail e/ou senha estão incorretos!`;
        toaster.show(msg, { type: "error" });
      }
    };

    const selecionaLocal = (local) => {
      /**
       * Registrando o local selecionado na sessão no cookie
       *
       */
      sso.registrarLocal(local);

      /**
       * Direciona o usuario para a home
       */
      enriquecerSessaoComMe()
        .then((usuario) => concluirLogin(usuario))
        .catch(() => router.push({ name: "home" }));
    };

    const loginGoogle = () => {
      // Fluxo OAuth completo; o Google costuma suprimir o One Tap por um período após isso.
      window.location.href = authService.urlRedirectGoogle();
    };

    /**
     *
     */
    const carregaLocais = () => {
      try {
        localService
          .buscarLocaisMock()
          .then((data) => {
            locaisList.value = data;
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.error("Erro ao buscar empresas", error);
        toaster.show(`Erro ao buscar empresa`, { type: "error" });
      }
    };

    carregaLocais();

    return {
      login,
      loginGoogle,
      selecionaLocal,
      carregaLocais,
      email,
      password,
      isLoading,
      locaisList,
      modoAdicionarConta,
    };
  },
};
</script>

<style scoped>
.login-divisor {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 1rem 0;
  color: var(--cor-fonte-fraca);
  font-size: 0.9rem;
}

.login-divisor::before,
.login-divisor::after {
  content: "";
  flex: 1;
  height: 1px;
  background: var(--cor-fonte-fraca);
}

.btn-google {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 40px;
  margin-top: 1rem;
  padding: 0 12px;
  background: #fff;
  border: 1px solid var(--cor-separador);
  border-radius: 20px;
  color: var(--cor-fonte);
  font-family: "Roboto", "Segoe UI", arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.btn-google:hover:not(:disabled) {
  background: #f8f9fa;
  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
}

.btn-google:focus-visible {
  outline: 2px solid #1a73e8;
  outline-offset: 2px;
}

.btn-google:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-google__icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.btn-google__text {
  white-space: nowrap;
}

.login-add-account {
  margin: 0 0 1rem;
  text-align: center;
  font-weight: 600;
  color: var(--cor-fonte);
}

.login-ajuda-senha {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.35rem 0.5rem;
  margin-top: 0.85rem;
  text-align: center;
}

.link-ajuda-senha {
  font-size: 0.9rem;
}

.login-ajuda-sep {
  color: var(--cor-fonte-fraca);
  opacity: 0.7;
}

.login-ajuda-hint {
  margin: 0.65rem 0 0;
  text-align: center;
  font-size: 0.78rem;
  line-height: 1.4;
  color: var(--cor-fonte-fraca);
}
</style>
